export enum BatchRolesEnum {
  BF_PLT_ENG = 'TST_LTL_BATCH_FRAMEWORK_PLT_ENG',
  BF_DCX = 'TST_LTL_BATCH_FRAMEWORK_DCX',
  BF_LEAD = 'TST_LTL_BATCH_FRAMEWORK_LEAD_TECH',
  BF_DEV = 'TST_LTL_BATCH_FRAMEWORK_DEV',
  BF_ADMIN = 'TST_LTL_BATCH_FRAMEWORK_ADMIN',
}
